/**
 * Validation Utilities
 * Centralized validation functions for forms.
 *
 * NOTE: the canonical email validator is utils/email.isValidEmail — do NOT add a
 * second one here (a divergent copy previously caused conflicting empty-input
 * semantics). This module owns only the postal-code check + the type-dispatching
 * validateMe used by the management pages' handleChange.
 */

/**
 * Validate German postal code
 */
export const isValidPostalCode = (code: string | null | undefined): boolean => {
  if (!code) return true; // Allow empty
  return /^(\d{5})$/.test(code);
};

/**
 * Type-dispatching field validator used by the management pages' handleChange:
 * validateMe(type, value). Returns true/false for "phone"/"email" and undefined
 * for any other type or empty input (so untyped fields don't gate the form).
 *
 * NOTE: keep these regexes — they are the ones the forms have always validated
 * against (ported verbatim from the former helpers/validation.js).
 */
export const validateMe = (
  type: string | null = null,
  input: string | null = null
): boolean | undefined => {
  if (type === "phone" && input) {
    const phoneCheck =
      // eslint-disable-next-line no-useless-escape
      /^([\+][0-9]{1,3}[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{6,18})((x|ext|extension)[ ]?[0-9]{1,4})?$/;
    const digits = input.replace(/\D/g, "");

    return phoneCheck.test(digits);
  }

  if (type === "email" && input) {
    const emailCheck =
      // eslint-disable-next-line no-useless-escape
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    return emailCheck.test(input);
  }
};

// Legacy alias kept for the many checkZip call sites.
export const checkZip = isValidPostalCode;
